import React, { useContext, useMemo } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Dialog from "components/Shared/Button/Dialog";
import { MDropzoneContext } from "components/Shared/MDropzone/contexts";
import { CASE_FILE_DELETE } from "typeConstants/rights";

const FileOverwriteDialog = ({ rights }) => {
  const {
    showDialog,
    closeDialog,
    overwriteFiles,
    filesThatWillOverwrite,
  } = useContext(MDropzoneContext);
  const canOverwrite = useMemo(
    () => rights && rights.includes(CASE_FILE_DELETE),
    [rights]
  );
  const message = useMemo(
    () => (filesThatWillOverwrite && filesThatWillOverwrite.length !== 0) && (
      filesThatWillOverwrite.length === 1
        ? `${filesThatWillOverwrite[0].name} Failed To Upload Because It Has The Same Name As Another File. Please Rename The File And Try Again.`
        : `${filesThatWillOverwrite.map(({ name }) => name).slice(0, -1).join(", ") + " and " + filesThatWillOverwrite[filesThatWillOverwrite.length - 1].name} Failed To Upload Because They Have The Same Names As Other Files. Please Rename These Files And Try Again.`
    ),
    [filesThatWillOverwrite]
  );
  return (
    <Dialog
      open={showDialog}
      title={"Overwrite Warning"}
      buttonPropSets={[
        ...(canOverwrite ? [{
          onClick: () => overwriteFiles(filesThatWillOverwrite),
          children: "Overwrite",
        }] : []),
        {
          onClick: closeDialog,
          children: "Cancel",
        },
      ]}
    >
      {message}
    </Dialog>
  );
};

FileOverwriteDialog.propTypes = {
  rights: PropTypes.array,
};

export default connect(
  state => ({
    rights: state.user.profile.rights,
  }),
)(FileOverwriteDialog);